// defer another network requests after initial frame is rendered
const defer = (fn: (this: Window, ev: Event) => unknown) => {
  const raf = window.requestAnimationFrame;

  if (raf)
    raf(function () {
      window.setTimeout(fn, 0);
    });
  else window.addEventListener("load", fn);
};

// use like
// <noscript id="deferred-styles">
//   <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:400,300italic,400italic,500,500italic,700,700italic&subset=latin,latin-ext">
//   <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto+Mono:400,700&subset=latin,latin-ext">
// </noscript>
// <script> deferStyles("deferred-styles") </script>
// (the <noscript> shouldn't be in the header due to spec, and the script
// does not work in the header in the bundled build, for some reason..)
export const deferStyles = (noscriptId: string, appendTo?: HTMLElement) => {
  defer(function () {
    const addStylesNode = document.getElementById(noscriptId);
    const replacement = document.createElement("div");
    replacement.innerHTML = addStylesNode?.textContent || "";

    const el = appendTo || document.body;
    el.appendChild(replacement);
    addStylesNode?.parentElement?.removeChild(addStylesNode);
  });
};
